
import { ColumnsActiveCampaignAdapter } from "helper/adapter/columsTable/columns-table-active-campaign-adapter";
import { SelectOptionInterface } from "../../../@types/entity/interface/select-option-interface";
import { getLocalStorage, updateLocalStorege } from "data/cache/localstorage-cache";
import { HeaderNavegationList } from "helper/adapter/headerNavigation/header-navegation-adapter";
import { ActiveCampaignsPlanningAdapter } from "helper/adapter/planning/active-campaigns-planning-adapter";
import { showErrorAlert, showWaitAlert, showSuccessAlert, showAlertPorStatus } from "helper/show-alert-helper";
import { checkColumns } from "helper/table-columns-helper";
import { getEnv } from "helper/window-helper";
import { UseAlert } from "hook/alert-hook";
import { UseAuth } from "hook/auth-hook";
import { ActiveCampaignsPage } from "pages/layout/analysis/active-campaigns-page"
import { useEffect, useState } from "react";
import { handleRequest } from "service/api/request-common";
import { RestCall } from "service/api/rest/rest-call";
import { RestUseCase } from "service/api/rest/rest-usecase";
import ErrorNotAuthorizedPage from "pages/layout/error/error-not-authorized-page";
import { useLoader } from "components/loader/loader-context";
import { useNavigate } from "react-router-dom";
import { FluxoAprovacaoPedidoUseCase } from "service/api/rest/fluxo-aprovacao-pedido-usecase";
import { finalizarOriginar } from "helper/fluxo-aprovacao-pedido-helper";
import { buscarConfiguracaoFluxoAprovacao } from "helper/fluxo-aprovacao-empresa-helper";
import { TableDescriptions } from "@interfaces/table-interface";
import { DadosPii } from "@interfaces/analysis/campaign-pii-data";

const toBoolean = (value: any) => value === true || value === 'true' || value === 1 || value === '1';

function getApiErrorMessage(response: any, fallbackMessage: string) {
  if (Array.isArray(response?.errors)) {
    const errorMessage = response.errors.find((error: any) => typeof error === 'string' && error.trim() !== '');

    if (errorMessage) {
      return errorMessage;
    }
  }

  if (typeof response?.message === 'string' && response.message.trim() !== '') {
    return response.message;
  }

  return fallbackMessage;
}

export const ActiveCampaignsFactory: React.FC = () => {
  const LOCALSTORAGE_COLUMS = getEnv('REACT_APP_LOCALSTORAGE_COLUMS_ACTIVE_CAMPAIGN')!;
  const LOCALSTORAGE_PLANNING = getEnv('REACT_APP_LOCALSTORAGE_PLANNING_ACTIVE_CAMPAIGN')!;
  const LOCALSTORAGE_PLANNING_ANALYTICAL = getEnv('REACT_APP_LOCALSTORAGE_PLANNING_ANALYTICAL')!;
  const ENDPOINT_ACTIVE_CAMPAIGNS = getEnv('REACT_APP_END_POINT_ACTIVE_CAMPAIGN');
  const LOCALSTORAGE_COLUMS_ORDER = getEnv('REACT_APP_LOCALSTORAGE_COLUMS_ACTIVE_CAMPAIGN')! + '_order';
  const LOCALSTORAGE_COLUMS_ORDER_ANALITYCAL = getEnv('REACT_APP_LOCALSTORAGE_COLUMS_ANALYTICAL')! + '_order';
  const ENDPOINT_FILIAL = getEnv('REACT_APP_END_POINT_FILIAL')!;
  const ENDPOINT_PLANNING = getEnv('REACT_APP_END_POINT_ACTIVE_CAMPAIGN') + '/filtros';
  const END_POINT_ITEM = getEnv('REACT_APP_END_POINT_ITEM');
  const END_POINT_MOVEMENT = getEnv('REACT_APP_END_POINT_MOVEMENT');
  const END_POINT_CORRELATE = getEnv('REACT_APP_END_POINT_CORRELATE_ICON')!;
  const END_POINT_ITEM_BASE_DESC = getEnv('REACT_APP_END_POINT_ITEM_BASE_DESC')!;
  const END_POINT_ITEM_BASE_CODE = getEnv('REACT_APP_END_POINT_ITEM_BASE_CODE')!;
  const ENDPOINT_COMPANIES_OBSOLETO = getEnv('REACT_APP_END_POINT_COMPANIES_OBSOLETO');
  const ENDPOINT_MANUFACTURER = getEnv('REACT_APP_END_POINT_MANUFACTURER')!;
  const ENDPOINT_LOCATIONS = getEnv('REACT_APP_END_POINT_LOCATIONS');
  const END_POINT_ORIGINAL_ITEMS_TRACKS = getEnv('REACT_APP_END_POINT_ORIGINAL_ITEMS_TRACKS')!;
  const END_POINT_ITEM_TRACKS = getEnv('REACT_APP_END_POINT_ITEM_TRACKS')!;
  const ENDPOINT_ANALYTICAL = getEnv('REACT_APP_END_POINT_ANALYTICAL')!;
  const ENDPOINT_FLUXO_APROVACAO_PEDIDO = getEnv('REACT_APP_END_POINT_FLUXO_APROVACAO_PEDIDO');

  const { showAlert } = UseAlert();
  const { loggedUserData } = UseAuth();
  const { showLoader, hideLoader } = useLoader()
  const navigate = useNavigate();

  const [isLoading, updateLoading] = useState<boolean>(false);
  const [isLoadingList, updateLoadingList] = useState<boolean>(false);
  const [isLoadingModal, updateLoadingModal] = useState<boolean>(false);
  const [showScreen, updateShowScreen] = useState<boolean>(false);
  const [branchOptions, updateBranchOptions] = useState<SelectOptionInterface[]>();
  const [campaignsOptions, updateCampaignsOptions] = useState<SelectOptionInterface[]>();
  const [meliOptions, updateMeliOptions] = useState<SelectOptionInterface[]>();

  const [companyObsoleto, updateCompanyObsoleto] = useState<SelectOptionInterface[]>();
  const [discountGroup, updateDiscountGroup] = useState<SelectOptionInterface[]>();
  const [baseDesc, updateBaseDesc] = useState<SelectOptionInterface[]>();
  const [baseCode, updateBaseCode] = useState<SelectOptionInterface[]>();
  const [rangeProfitability, updateRangeProfitability] = useState<SelectOptionInterface[]>();
  const [manufacturer, updateManufacturer] = useState<SelectOptionInterface[]>();
  const [locationList, updateLocationList] = useState<SelectOptionInterface[]>([]);
  const [fluxoAprovacao, updateFluxoAprovacao] = useState<boolean | null>(null);
  const [fluxoAprovacaoCompleto, updateFluxoAprovacaoCompleto] = useState<boolean | null>(null);

  useEffect(() => {
    findBranchs();
    checkColumns(LOCALSTORAGE_COLUMS, ColumnsActiveCampaignAdapter);
    handleDiscountGroup();
    handleRangeProfitability();
    handleBaseDesc();
    handleBaseCode();
    handleManufacturer();
    handleCompanyObsoleto();
    listLocations();
    findMeliOptions();
  }, []);

  useEffect(() => {
    const roleScreen = HeaderNavegationList.filter((header) => header.navTitle === 'Análise')[0].navItem.filter((item) => item.title === 'Analítico')[0].role;

    if (loggedUserData?.role) {
      loggedUserData.role.forEach((value) => {
        if (roleScreen.includes(value)) updateShowScreen(true);
      });
    }
    findCompanyConfiguration();
  }, [loggedUserData]);

  useEffect(() => {
    if (isLoading || isLoadingList) {
      showLoader()
    }
    if (!isLoading && !isLoadingList) {
      hideLoader()
    }
  }, [isLoading, isLoadingList])

  useEffect(() => {
    ActiveCampaignsPlanningAdapter.map((value) => {
      if (value.label === 'Grupo de desconto') value.field[1].optionsInput = discountGroup;
      if (value.label === 'Base') {
        value.field[1].optionsInput = baseCode;
      }
      if (value.label === 'Base Descrição') {
        value.field[1].optionsInput = baseDesc;
      }
      if (value.label === 'Lucratividade do fornecedor') value.field[1].optionsInput = rangeProfitability;
      if (value.label === 'Obsoleto') {
        value.field[1].optionsInput = companyObsoleto;
      }
      if (value.label === 'Código do Fabricante') value.field[1].optionsInput = manufacturer;
      if (value.label === 'Locações') value.field[1].optionsInput = locationList;
      if (value.label === 'Observação em item') {
        const fetchOptions = value.field[1].fetchOptions;
        if (fetchOptions && loggedUserData?.companyId) {
          fetchOptions(loggedUserData.companyId).then((options: { label: string; value: number }[]) => {
            value.field[1].optionsInput = options;
          });
        }
      }
      if (value.label === 'Data da última venda') {
        const fetchOptions = value.field[1].fetchOptions;
        if (fetchOptions && loggedUserData?.companyId) {
          fetchOptions(loggedUserData.companyId).then((options: { label: string; value: number }[]) => {
            value.field[1].optionsInput = options;
          });
        }
      }
      if (value.label === 'Data da ultima compra') {
        const fetchOptions = value.field[1].fetchOptions;
        if (fetchOptions && loggedUserData?.companyId) {
          fetchOptions(loggedUserData.companyId).then((options: { label: string; value: number }[]) => {
            value.field[1].optionsInput = options;
          });
        }
      }
    });

    ActiveCampaignsPlanningAdapter.sort(function (a, b) {
      return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
    });
  }, [discountGroup, rangeProfitability, companyObsoleto, manufacturer, baseDesc, baseCode, locationList, loggedUserData]);

  const handleCompanyObsoleto = async () => {
    await new RestUseCase(ENDPOINT_COMPANIES_OBSOLETO).Get().then((response) => {
      updateCompanyObsoleto(
        response.body.map((value: any) => {
          return { value: value.id, label: value.nome };
        })
      );
    });
  };
  const handleDiscountGroup = async () => {
    await new RestUseCase(END_POINT_ORIGINAL_ITEMS_TRACKS).Get().then((response) => {
      updateDiscountGroup(
        response.body.map((value: any) => {
          return { value: value, label: value };
        })
      );
    });
  };
  const handleRangeProfitability = async () => {
    await new RestUseCase(END_POINT_ITEM_TRACKS).Get().then((response) => {
      updateRangeProfitability(
        response.body.map((value: any) => {
          return { value: value, label: value };
        })
      );
    });
  };
  const handleBaseDesc = async () => {
    await new RestUseCase(END_POINT_ITEM_BASE_DESC).Get().then((response) => {
      updateBaseDesc(
        response.body.descricoes.map((value: any) => {
          return {
            value: value,
            label: value,
          };
        })
      );
    });
  };

  const handleBaseCode = async () => {
    await new RestUseCase(END_POINT_ITEM_BASE_CODE).Get().then((response) => {
      updateBaseCode(
        response.body.codigos.map((value: any) => {
          return {
            value: value,
            label: value,
          };
        })
      );
    });
  };

  const handleManufacturer = async () => {
    await new RestUseCase(ENDPOINT_MANUFACTURER).Get().then((response) => {
      updateManufacturer(
        response.body.map((value: any) => {
          return {
            value: value.codigo,
            label: `${value.codigo} - ${value.nome}`,
          };
        })
      );
    });
  };

  async function listLocations(): Promise<any> {
    await new RestUseCase(ENDPOINT_LOCATIONS).Get().then((response) => {
      if (response.statusCode !== 500 && response.statusCode !== undefined) {
        updateLocationList(
          response.body.locacoes.map((value: any) => {
            return { value: value.codigo, label: value.codigo };
          })
        );
      }
    });
  }

  const findBranchs = async () => {
    await new RestUseCase(`${ENDPOINT_FILIAL}?modulos=COMPRAS`).Get().then((response) => {
      updateBranchOptions(
        response.body.map((value: any) => {
          return { value: value.id, label: value.nome };
        })
      );
    });
  };

  const findCampaigns = async (idBranch: number) => {
    updateLoading(true);
    await new RestCall(ENDPOINT_ACTIVE_CAMPAIGNS! + '/listar/' + idBranch)
      .Get()
      .then((response) => {
        if (response.success) {
          updateCampaignsOptions(
            (response.data ?? []).map((value: any) => {
              return { value: value.id, label: value.descricao, campanhaFull: toBoolean(value.campanhaFull ?? value.pacBlnCampanhaFull) };
            })
          );
          updateLoading(false);
        } else {
          showErrorAlert(showAlert, 'Error ao listar camapnhas');
          updateLoading(false);
        }
      })
      .catch((error) => {
        showErrorAlert(showAlert, 'Error ao listar camapnhas');
        updateLoading(false);
      });
  };

  const findMeliOptions = async () => {
    await new RestCall(ENDPOINT_ACTIVE_CAMPAIGNS! + '/codigos-meli')
      .Get()
      .then((response) => {
        if (response.success) {
          updateMeliOptions(
            (response.data ?? []).map((value: any) => {
              const codigo = value.codigoMeli ?? value.codigo ?? value.value ?? value.id ?? value;
              const descricao = value.descricao ?? value.label;
              return { value: codigo, label: descricao ? `${codigo} - ${descricao}` : String(codigo) };
            })
          );
        } else {
          updateMeliOptions([]);
          showErrorAlert(showAlert, 'Erro ao listar códigos MELI');
        }
      })
      .catch(() => {
        updateMeliOptions([]);
        showErrorAlert(showAlert, 'Erro ao listar códigos MELI');
      });
  };

  async function listAnalitycal(params: { pagination: string; model?: any }): Promise<any> {
    showWaitAlert(showAlert, "Aguarde um momento")
    updateLoadingModal(true)

    let localStorageColumsOrder: any[] = getLocalStorage(LOCALSTORAGE_COLUMS_ORDER_ANALITYCAL) ?? [];

    let queryParamsOrder = '';

    localStorageColumsOrder.forEach((fe) => {
      if (fe.ordinationValue) {
        queryParamsOrder += `&sort=${fe.ordinationName.toLowerCase()}:${fe.ordinationValue}`;
      }
    });

    var dataPlanning = params.model ? params.model : getLocalStorage(LOCALSTORAGE_PLANNING_ANALYTICAL);

    const response = await new RestUseCase(ENDPOINT_ANALYTICAL! + params?.pagination + queryParamsOrder).Post({
      data: dataPlanning ? dataPlanning : undefined,
    }).then((response) => {
      if (response.statusCode !== 200) {
        showErrorAlert(showAlert, "Erro na busca de dados")
        updateLoadingModal(false)
        return response
      } else {
        updateLoadingModal(false)
        return response
      }
    });

    if (response.statusCode !== 200) {
      updateLocalStorege(LOCALSTORAGE_PLANNING, []);
    }

    return handleRequest(response);
  }

  async function list(params: { pagination: string; model?: any; idBranch?: number; idCampaign?: number }): Promise<any> {
    showWaitAlert(showAlert, 'Aguarde um momento');
    updateLoadingList(true);

    let localStorageColumsOrder: any[] = getLocalStorage(LOCALSTORAGE_COLUMS_ORDER) ?? [];
    let queryParamsOrder = '';

    localStorageColumsOrder.forEach((fe) => {
      if (fe.ordinationValue) {
        queryParamsOrder += `&sort=${fe.ordinationName.toLowerCase()}:${fe.ordinationValue}`;
      }
    });

    let dataPlanning = filterHandler(params);
    let response = await new RestCall(ENDPOINT_ACTIVE_CAMPAIGNS! + '/listar' + params?.pagination + queryParamsOrder)
      .Post({
        data: dataPlanning ? dataPlanning : undefined,
      })
      .then((response) => {
        if (!response.success) {
          showErrorAlert(showAlert, response.message);
        }

        return response;
      });

    updateLoadingList(false);
    return response;
  }

  function filterHandler(params: { pagination?: string; model?: any; idBranch?: number; idCampaign?: number }) {
    let filtersPlanning: any[] = [];
    if (params.idBranch !== undefined && params.idCampaign !== undefined) {
      filtersPlanning = [
        {
          type: 'FILIAL',
          params: {
            type: 'IN',
            filiais: [params.idBranch],
          },
        },
        {
          type: 'CAMPANHA',
          params: {
            type: 'EQUALS',
            campanha: params.idCampaign,
          },
        },
      ];
    }

    const baseData = params?.model ?? getLocalStorage(LOCALSTORAGE_PLANNING) ?? [];
    return [...baseData, ...filtersPlanning];
  }

  async function getActiveCampaignsTotals(idIntencao: number, idBranch: number, idCampaign: number): Promise<any> {
    updateLoading(true);

    let filtersPlanning: any[] = [];
    if (idBranch !== undefined && idCampaign !== undefined) {
      filtersPlanning = [
        ...filtersPlanning,
        {
          type: 'FILIAL',
          params: {
            type: 'IN',
            filiais: [idBranch],
          },
        },
        {
          type: 'CAMPANHA',
          params: {
            type: 'EQUALS',
            campanha: idCampaign,
          },
        },
      ];
    }

    return await new RestCall(ENDPOINT_ACTIVE_CAMPAIGNS! + '/listar/totais/' + idIntencao)
      .Post({
        data: filtersPlanning,
      })
      .then((response) => {
        if (response.success) {
          showSuccessAlert(showAlert, response.message);
          updateLoading(false);
          return response;
        } else {
          showErrorAlert(showAlert, response.message);
          updateLoading(false);
          return response;
        }
      });
  }

  async function getExcel(idBranch: number, idCampaign: number, columns: TableDescriptions[]): Promise<any> {
    let dataPlanning = filterHandler({ idBranch, idCampaign });

    // Filtrar apenas colunas visíveis e ordenar
    const visibleColumns = columns
      .filter(column => {
        return !column.hidden && column.text !== 'ID' && column.text !== 'ALERTA' && column.text !== 'Observação'
      })
      .sort((a, b) => a.order - b.order)
      .map(column => ({
        dataField: column.dataField,
        text: column.text,
        order: column.order,
        align: column.align,
        numberFormat: column.numberFormat,
        hidden: column.hidden,
      }));

    const response = await new RestUseCase(ENDPOINT_ACTIVE_CAMPAIGNS! + "/gerar-excel").Post({
      responseType: 'blob',
      data: {
        filters: dataPlanning,
        columns: visibleColumns
      },
    });

    return handleRequest(response);
  }

  async function save(params: { idIntencao: number; item: any[] }): Promise<any> {
    updateLoading(true);
    await new RestCall(ENDPOINT_ACTIVE_CAMPAIGNS! + '/item-intencao-compra/' + params.idIntencao).Post({ data: params.item }).then((response) => {
      if (response.success) {
        showSuccessAlert(showAlert, response.message);
        updateLoading(false);
      } else {
        showErrorAlert(showAlert, response.message);
        updateLoading(false);
      }
    });
  }

  async function removePendingQuantities(idIntencao: number): Promise<any> {
    updateLoading(true);
    return await new RestCall(ENDPOINT_ACTIVE_CAMPAIGNS! + '/item-intencao-compra/' + idIntencao).Delete().then((response) => {
      if (response.success) {
        showSuccessAlert(showAlert, response.message);
        updateLoading(false);
        return response;
      } else {
        showErrorAlert(showAlert, response.message);
        updateLoading(false);
        return response;
      }
    });
  }

  async function sendOrder(idIntencao: number, idBranch: number, idCampaign: number, dadosPii?: DadosPii): Promise<any> {
    updateLoading(true);
    return await new RestCall(ENDPOINT_ACTIVE_CAMPAIGNS! + '/intencao-compra')
      .Post({
        data: {
          idIntencaoCompra: idIntencao,
          idFilial: idBranch,
          idCampanha: idCampaign,
          ...(dadosPii !== undefined ? { dadosPii } : {}),
        },
      })
      .then((response) => {
        if (response.success) {
          showSuccessAlert(showAlert, response.message);
          updateLoading(false);
        } else {
          showErrorAlert(showAlert, getApiErrorMessage(response, 'Erro ao enviar pedido'));
          updateLoading(false);
        }
        return response;
      })
      .catch((error) => {
        showErrorAlert(showAlert, getApiErrorMessage(error, 'Erro ao enviar pedido'));
        updateLoading(false);
        return {
          success: false,
          message: getApiErrorMessage(error, 'Erro ao enviar pedido'),
          statusCode: error?.statusCode ?? 500,
          data: null,
          errors: error?.errors ?? [],
        };
      });
  }

  async function requestOrderLegado(idIntencao: number): Promise<any> {
    updateLoading(true);
    await new RestCall(ENDPOINT_ACTIVE_CAMPAIGNS! + '/solicitar-compra')
      .Post({
        data: { idIntencaoCompra: idIntencao },
      })
      .then((response) => {
        if (response.success) {
          showSuccessAlert(showAlert, response.message);
          updateLoading(false);
        } else {
          showErrorAlert(showAlert, response.message);
          updateLoading(false);
        }
      });
  }

  async function requestOrder(idIntencao: number, orderName?: string): Promise<any> {
    if (fluxoAprovacaoCompleto !== true) {
      return requestOrderLegado(idIntencao);
    }
    // Fluxo novo (flag da empresa ligada): origina o pedido versionado a partir da intenção de
    // compra (mesmo gatilho do legado, por idIntencaoCompra), agrupando por filial, e leva para a
    // tela de Aprovação de Pedidos. Espelha Analítico/Sintético e NÃO chama o /solicitar-compra legado.
    updateLoading(true);
    const resultado = await new FluxoAprovacaoPedidoUseCase(ENDPOINT_FLUXO_APROVACAO_PEDIDO!).originarDeCampanhas(idIntencao, orderName?.trim() || null);
    updateLoading(false);
    finalizarOriginar(
      resultado,
      () => navigate('/fluxo-aprovacao-pedido?aba=campanhas'),
      (mensagem, statusCode) => showAlertPorStatus(showAlert, mensagem, statusCode)
    );
  }

  async function createPlanning(params?: any): Promise<any> {
    return await new RestUseCase(ENDPOINT_PLANNING!).Post({ data: params }).then((response) => {
      if (response.statusCode !== 500) {
        showSuccessAlert(showAlert, 'Planejamento criado com sucesso');
        return handleRequest(response);
      } else {
        updateLocalStorege(LOCALSTORAGE_PLANNING, []);
        showErrorAlert(showAlert, 'Ops!!! Algo deu errado tente novamente mais tarde...');
        return response;
      }
    });
  }

  async function editPlanning(params: { model: any; id: number }): Promise<any> {
    return await new RestUseCase(ENDPOINT_PLANNING! + '/' + params.id).Put({ data: params.model }).then((response) => {
      if (response.statusCode !== 500) {
        showSuccessAlert(showAlert, 'Planejamento editado com sucesso');
        return handleRequest(response);
      } else {
        updateLocalStorege(LOCALSTORAGE_PLANNING, []);
        showErrorAlert(showAlert, 'Ops!!! Algo deu errado tente novamente mais tarde...');
        return response;
      }
    });
  }

  async function removePlanning(params?: any): Promise<any> {
    await new RestUseCase(ENDPOINT_PLANNING! + '/' + params.idFilter).Delete().then((response) => {
      if (response.statusCode !== 500) {
        showSuccessAlert(showAlert, 'Planejamento excluido com sucesso');
        return handleRequest(response);
      } else {
        updateLocalStorege(LOCALSTORAGE_PLANNING, []);
        showErrorAlert(showAlert, 'Ops!!! Algo deu errado tente novamente mais tarde...');
      }
    });
  }

  async function listAllPlanning(): Promise<any> {
    return await new RestUseCase(ENDPOINT_PLANNING!).Get().then((response) => {
      if (response.statusCode !== 500) {
        showSuccessAlert(showAlert, 'Planjemanetos listados com sucesso');
        return handleRequest(response);
      } else {
        updateLocalStorege(LOCALSTORAGE_PLANNING, []);
        showErrorAlert(showAlert, 'Ops!!! Algo deu errado tente novamente mais tarde...');
        return response;
      }
    });
  }

  const graphicHistory = async (id: number) => {
    updateLoadingModal(true)
    return await new RestUseCase(`${ENDPOINT_ANALYTICAL}/historico/${id}`).Get().then((response) => {
      if (response.statusCode !== 500) {
        showSuccessAlert(showAlert, "Historico encontrado com sucesso")
        updateLoadingModal(false)
        return handleRequest(response);
      } else {
        updateLocalStorege(LOCALSTORAGE_PLANNING, []);
        showErrorAlert(showAlert, "Ops!!! Algo deu errado tente novamente mais tarde...")
        updateLoadingModal(false)
        return response
      }
    });
  };
  const observationItem = async (params: { fitStrCodFabricante: number; filial: number }) => {
    updateLoadingModal(true)
    return await new RestUseCase(`${END_POINT_ITEM}/${params.fitStrCodFabricante}/observacoes?filiais=${params.filial}`).Get().then((response) => {
      if (response.statusCode !== 500) {
        showSuccessAlert(showAlert, "Observação encontrada com sucesso")
        updateLoadingModal(false)
        return handleRequest(response);
      } else {
        updateLocalStorege(LOCALSTORAGE_PLANNING, []);
        showErrorAlert(showAlert, "Ops!!! Algo deu errado tente novamente mais tarde...")
        updateLoadingModal(false)
        return response
      }
    });
  };
  const movement = async (params: { codigoItem: number; idFilial: number; typeMoviment: 'compra' | 'venda' }) => {
    updateLoadingModal(true)
    return await new RestUseCase(`${END_POINT_MOVEMENT}/${params.typeMoviment}?codigoItem=${params.codigoItem}&idFilial=${params.idFilial}`).Get().then((response) => {
      if (response.statusCode !== 500) {
        showSuccessAlert(showAlert, "Dados encotrados com sucesso")
        updateLoadingModal(false)
        return handleRequest(response);
      } else {
        updateLocalStorege(LOCALSTORAGE_PLANNING, []);
        showErrorAlert(showAlert, "Ops!!! Algo deu errado tente novamente mais tarde...")
        updateLoadingModal(false)
        return response
      }
    })
  };
  const correlate = async (params: { codigoItem: number }) => {
    updateLoadingModal(true)
    return await new RestUseCase(`${END_POINT_CORRELATE}/?codigo=${params.codigoItem}`).Get().then((response) => {
      if (response.statusCode !== 500) {
        showSuccessAlert(showAlert, "Itens correlatos encontrados com sucesso")
        updateLoadingModal(false)
        return handleRequest(response);
      } else {
        updateLocalStorege(LOCALSTORAGE_PLANNING, []);
        showErrorAlert(showAlert, "Ops!!! Algo deu errado tente novamente mais tarde...")
        updateLoadingModal(false)
        return response
      }
    });
  };

  async function findCompanyConfiguration() {
    const resultado = await buscarConfiguracaoFluxoAprovacao(loggedUserData?.companyId, loggedUserData?.role);
    updateFluxoAprovacaoCompleto(resultado.fluxoAprovacaoCompleto);
    updateFluxoAprovacao(resultado.fluxoAprovacao);
    if (!resultado.success) {
      showErrorAlert(showAlert, resultado.message);
    }
  }

  return (
    <>
      {showScreen ? (
        <ActiveCampaignsPage
          isLoadingModal={isLoadingModal}
          loggedUserDataRole={loggedUserData?.role!}
          listAnalitycal={listAnalitycal}
          list={list}
          save={save}
          getActiveCampaignsTotals={getActiveCampaignsTotals}
          getExcel={getExcel}
          removePendingQuantities={removePendingQuantities}
          sendOrder={sendOrder}
          requestOrder={requestOrder}
          branchOptions={branchOptions}
          campaignsOptions={campaignsOptions}
          meliOptions={meliOptions}
          findCampaigns={findCampaigns}
          createPlanning={createPlanning}
          editPlanning={editPlanning}
          removePlanning={removePlanning}
          listAllPlanning={listAllPlanning}
          optionsFiltersDefault={ActiveCampaignsPlanningAdapter}
          correlate={correlate}
          graphicHistory={graphicHistory}
          movement={movement}
          observationItem={observationItem}
          fluxoAprovacao={fluxoAprovacao}
        />
      ) : (
        <ErrorNotAuthorizedPage />
      )}
    </>
  );
};
